import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

export const createPrivateDocument = async ({
  projectId,
  title,
  templateId,
  topic_id,
  gapReportId,
  content,
}: {
  projectId: string
  title?: string
  templateId?: string
  topic_id?: string
  gapReportId?: string
  content?: unknown
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post('/items', {
      item_type: 'private_doc',
      project_id: projectId,
      doc_title: title,
      document_template_id: templateId,
      topic_id,
      content_gap_report_id: gapReportId,
      content,
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
